export const CHAT_SCROLL_FOLLOW_THRESHOLD_PX = 96;

export interface ScrollMetrics {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

/**
 * Treat a reader close to the tail as following the live reply. This gives
 * normal wheel/touch rounding a little tolerance while preserving an
 * intentionally scrolled-up reading position.
 */
export function isNearScrollBottom(
  { scrollTop, scrollHeight, clientHeight }: ScrollMetrics,
  threshold = CHAT_SCROLL_FOLLOW_THRESHOLD_PX
): boolean {
  return scrollHeight - clientHeight - scrollTop <= threshold;
}
